import React from "react"
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import Homepage from "./Homepage"
import './i18n'
import Login from "./Login"
import Signup from "./Signup"
import Consultation from "./Consultation"
import Shop from "./Shop"
import Product from "./Itempage"
import Success from "./Success"
import Contact from "./Contact"
import ForgotPassword from "./ForgotPassword"
import ResetPassword from "./ResetPassword"
import FAQ from "./FAQ"
import About from "./About"
import CoachDashboard from "./CoachDashboard";
import CartPage from "./CartPage"
import OrderConfirmation from './OrderConfirmation'
import Coach from "./Coach"
import Profile from "./Profile"
/* import Temporary from "./Temporary" */
import LawSide from "./LawSide"

const App = () => {
  return (
    <Router>
    <Routes>
    {/* <Route path="/" element={<Temporary />} /> */}
      <Route path="/" element={<Homepage />} />
      <Route path="/login" element={<Login/>}/>
      <Route path="/signup" element={<Signup/>}/>
      <Route path="/coach" element={<Coach/>}/>
      <Route path="/consultation" element={<Consultation/>}/>
      <Route path="/about" element={<About/>}/>
      <Route path="/shop" element={<Shop/>}/>
      <Route path="/success" element={<Success/>}/>
      <Route path="/contact" element={<Contact/>}/>
      <Route path="/faq" element={<FAQ/>}/>
      <Route path="/shop/:id" element={<Product/>}/>
      <Route path="/forgot-password" element={<ForgotPassword/>}/>
      <Route path="/reset-password" element={<ResetPassword/>}/>
      <Route path="/coach-dashboard" element={<CoachDashboard/>}/>
      <Route path="/cart/:id" element={<CartPage />} />
      <Route path="/cart/guest" element={<CartPage />} />
      <Route path="/orderConfirmation" element={<OrderConfirmation />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/termes-et-conditions" element={<LawSide/>} />
    </Routes>
  </Router>
  );
}

export default App;
